export default __webpack_public_path__ + "static/hw_servo-bedbb3dd25aa21b9b41f13335c64e06b.jpg";